<template>
	<div>
		<modalconfirm ref="modalconfirmApproveSO" @action="proccessSO"/>
		<div class="text-h5">Approval Sales Order</div>
		<v-card class="mt-3" outlined>
			<v-form ref="formSO" role="form" v-on:submit.prevent="ApprovalSO">
				<v-card-text class="pt-2">
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="6" sm="4" md="4">
							<v-autocomplete :items="OptionSoToApprove" v-model="so_code" @change="getDetail(so_code)" :rules="[inputrules.required]" label="Kode Sales Order" no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.payment_method=''" :error-messages="responseError.payment_method" item-text="so_code" item-value="so_code" outlined dense hide-details="auto" :filter="customFilter">
								<template v-slot:item = {item}>
									{{item.so_code}} - {{item.customer_network_code}} - {{item.customer_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.so_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="detailSO">
							<v-row>
								<v-col cols="4" class="py-0">
									<div class="text-subtitle-2 font-weight-bold">Mitra</div>
									<div class="text-body-2">{{ detailSO.customer_network_code }} - {{ detailSO.customer_name }}</div>
								</v-col>
								<v-col cols="5" class="py-0">
									<div class="text-subtitle-2 font-weight-bold">Alamat</div>
									<div class="text-body-2">{{ addressText(detailSO) }}</div>
								</v-col>
								<v-col cols="3" class="pb-0">
									<div class="text-subtitle-2 font-weight-bold">Level Mitra</div>
									<div class="text-body-2">{{detailSO.customer_level.toUpperCase()}} <span v-if="detailSO.customer_level !== 'mb'">({{parseInt(detailSO.customer_order_count)}})</span></div>
								</v-col>
								<v-col cols="4" class="pb-0">
									<div class="text-subtitle-2 font-weight-bold">Pembayaran</div>
									<div class="text-body-2" v-html="detailSO.so_payment_note_full ? detailSO.so_payment_note_full : '-'"></div>
								</v-col>
								<v-col cols="4" class="py-0">
									<div class="text-subtitle-2 font-weight-bold">Catatan</div>
									<div class="text-body-2">{{ detailSO.so_note ? detailSO.so_note : '-' }}</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" >
							<div class="text-subtitle-2 font-weight-bold">Data Order</div>
							<v-simple-table class="pt-3">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="15%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-center">Harga Produk (Rp)</th>
											<th width="15%" class="text-center">Jumlah</th>
											<th width="15%" class="text-center">Sub Total (Rp)</th>
										</tr>
									</thead>
									<tbody v-if="detailSO.so_detail">
										<tr v-for="(product, index) in detailSO.so_detail" :key="index">
											<td> {{ product.so_detail_product_name }} </td>
											<td> {{ product.so_detail_product_code }} </td>
											<td class="text-center"> {{ product.so_detail_product_price | toNumber }} </td>
											<td class="text-center"> {{ product.so_detail_quantity_sold | toNumber }} {{product.so_detail_product_unit}}</td>
											<td class="text-center"> {{ product.so_detail_product_price *product.so_detail_quantity_sold | toNumber }} </td>
										</tr>
									</tbody>
									<tfoot class="v-data-table-footer" v-if="detailSO.so_detail">
										<tr>
											<th width="40%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left">Diskon :</th>
											<th width="15%" class="text-center">{{ discountTotal | toNumber}}</th>
										</tr>
										<tr>
											<th width="40%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left">Potongan Harga :</th>
											<th width="15%" class="text-center">{{ detailSO.so_rebate_value | toNumber}}</th>
										</tr>
										<tr v-if="detailSO.so_materai_value > 0">
											<th width="40%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left">Materai :</th>
											<th width="15%" class="text-center">{{ detailSO.so_materai_value | toNumber}}</th>
										</tr>
										<tr>
											<th width="40%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left"></th>
											<th width="15%" class="text-left">Total Pembayaran :</th>
											<th width="15%" class="text-center">{{ totalPayment - discountTotal - detailSO.so_rebate_value + parseInt(detailSO.so_materai_value) | toNumber}}</th>
										</tr>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-4 pb-4">
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit">Proses</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			so_code: '',
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
		}
	},
	props: {
	},
	computed: {
		...mapState('so', ['detailSO', 'OptionSoToApprove', 'responseError', 'response', 'alertMultiple']),

		totalPayment() {
			let total = 0

			if (this.detailSO.so_detail) {
				this.detailSO.so_detail.forEach( el => {
					total += el.so_detail_quantity_sold * el.so_detail_product_price
				});
			}
			return total
		},
		
		discountTotal() {
			return this.detailSO.so_discount_percent * this.totalPayment / 100
		},
	},
	methods: {
		...mapActions('so', ['getDetailSO', 'getOptionSOforApprove', 'approveSO']),
		...mapMutations('so', ['saveResponse', 'clearDataSO', 'setDetailSO']),
		...mapMutations(['setOverlay']),

		addressText(value) {
			var data = []
			if (value.customer_address)
				data.push(value.customer_address)
			if (value.customer_subdistrict_name)
				data.push(value.customer_subdistrict_name)
			if (value.customer_city_name)
				data.push(value.customer_city_name)
			if (value.customer_province_name)
				data.push(value.customer_province_name)
			return data.join(', ')
		},
		getDetail(code) {
			if (code) {
				this.getDetailSO(code)
			} else {
				this.setDetailSO('')
			}
		},
		ApprovalSO() {
			if (this.$refs.formSO.validate()) {
				this.$refs.modalconfirmApproveSO.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				this.$refs.modalconfirmApproveSO.showConfirm()
			}
		},
		async proccessSO() {
			await this.setOverlay(true)
				await this.$refs.modalconfirmApproveSO.hideConfirm()
			let params = await {
				so_id: this.detailSO.so_id,
			}
			await this.approveSO(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse({})
			this.so_code = ''
			this.$refs.formSO.resetValidation()
			this.setDetailSO('')
			this.getOptionSOforApprove()
		},
		customFilter (item, queryText) {
			const textOne = item.so_code.toLowerCase()
			const textTwo = item.customer_name.toLowerCase()
			const textThree = item.customer_network_code.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1 ||
			textThree.indexOf(searchText) > -1
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Sales Order`)
		this.getOptionSOforApprove().then(() => {
			if (this.$route.params.code) {
				this.so_code = this.$route.params.code
				this.getDetailSO(this.$route.params.code)
			}
		})
	},
	beforeDestroy(){
		this.clearDataSO()
	},
	watch: {
	}
};
</script>